import jQuery from 'jquery'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

class ProgramsSlider {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    this._iniSlider()
  }

  _iniSlider() {
    const carousel = this.$element.find('.s-programs-for-you__items')[0]

    this.swiper = new Swiper(carousel, {
      modules: [Navigation, Pagination],
      spaceBetween: 0,
      slidesPerView: 'auto',
      pagination: {
        clickable: true,
        el: '.s-programs-for-you__slider .swiper-pagination',
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
      },
    })
  }
}

export default ProgramsSlider
